import axios from 'axios';
import config from '../config';
import { LoginResponse } from '../types/auth.types';

export interface LoginCredentials {
  userName: string;
  password: string;
}

const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await axios.post<LoginResponse>(`${config.API_BASE_URL}/Auth/login`, credentials);
    return response.data;
  },
  logout: async (): Promise<void> => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        await axios.post(`${config.API_BASE_URL}/Auth/logout`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch { /* Non-critical — clear local state regardless */ }
    }
  },
};

export default authService;